import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const TribeAuthContext = createContext(null);

export const useTribeAuth = () => useContext(TribeAuthContext);

export const TribeAuthProvider = ({ children }) => {
  const [tribe, setTribe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/tribe/me");
      setTribe(res.data);
    } catch (e) {
      setTribe(false);
      if (e?.response?.status && e.response.status !== 401) console.error("Tribe session check failed:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const res = await api.post("/tribe/login", { email, password });
    setTribe(res.data.tribe);
    return res.data.tribe;
  };

  const register = async (payload) => {
    const res = await api.post("/tribe/register", payload);
    setTribe(res.data.tribe);
    return res.data.tribe;
  };

  const logout = async () => {
    try {
      await api.post("/tribe/logout");
    } catch (e) {
      console.error("Tribe logout request failed:", e);
    }
    setTribe(false);
  };

  return (
    <TribeAuthContext.Provider value={{ tribe, setTribe, loading, refresh, login, register, logout }}>
      {children}
    </TribeAuthContext.Provider>
  );
};
